import(/* webpackMode: "eager" */ "/vercel/path0/app/smart-apply/onboarding/page.jsx");
